export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyB0_1udik7DCQNSpb-Mb83KBFU3NNiDyW0",
  authDomain: "neat-with-nat.firebaseapp.com",
  projectId: "neat-with-nat",
  storageBucket: "neat-with-nat.appspot.com",
  messagingSenderId: "29197622631",
  appId: "1:29197622631:web:5e1a5d729e2d0c3e0f63c2",
  measurementId: "G-6S325VZGF0",
};
